import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${props => props.theme.carvana.gray.background};
  border-radius: 3px;
  padding: 5px 20px 14px 20px;
  width: 233px;
  margin-bottom: 20px;

  &.top-padding {
    padding-top: 14px;
  }
  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    width: 213px;
  }
`;

export const Price = styled.span`
  color: ${props => props.theme.carvana.blue.primary};
  font-size: 30px;
  font-weight: 400;
  letter-spacing: -0.91px;
`;

export const CarImageOuterWrapper = styled.span`
  align-items: center;
  display: flex;
  &.bottom-spacing {
    margin-bottom: 5px;
  }
`;

export const CarImageWrapper = styled.span`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  margin-left: 2.5px;
  &.extra-image-padding {
    padding: 5px 0px 5px 5px;
  }
`;

export const CarImageInnerWrapper = styled.div`
  border-radius: 50px;
  height: 37px;
  width: 37px;
  overflow: hidden;
`;

export const CarImage = styled.img`
  margin-left: -15px;
  height: 100%;
  max-width: unset;
`;

export const Subtitle = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;

  &.bottom-padding {
    padding-bottom: 4px;
  }
`;

export const Title = styled.div`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  margin: 4px 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const Button = styled.a`
  align-items: center;
  background-color: ${props => props.theme.carvana.blue.primary};
  border-radius: 3px;
  color: ${props => props.theme.carvana.white.primary};
  display: flex;
  font-size: 12px;
  font-weight: 700;
  height: 28px;
  justify-content: center;
  text-transform: uppercase;
  width: 100%;

  &:hover {
    background-color: ${props => props.theme.carvana.blue.hover};
    color: ${props => props.theme.carvana.white.primary};
    text-decoration: none;
  }
`;

export const DollarSign = styled.sup`
  font-size: 15px;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
  top: -0.65em;
`;
